import { useLayoutEffect, useState } from 'react';
import APIS from '../api/api';
import React from 'react';
import View from '../view/top';
import BannerData from '../model/top/bannerData';
import NewsData from '../model/top/newsData';
import CharacterBannerData from '../model/top/characterBannerData';
import RoadMapData from '../model/top/roadmapData';

const Presenter: React.FC = () => {
    const [banner, setBannerData] = useState<BannerData[]>([]);
    const [charBanner, setCharacterBannerData] = useState<CharacterBannerData>({mstCharacterIdsUpper:[], mstCharacterIdsLower:[]});
    const [newsData, setNewsData] = useState<NewsData[]>([]);
    const [isSuccess, SetIsSuccess] = useState<boolean>(false);
    const [roadMapData, setRoadMapData] = useState<RoadMapData[]>([]);

    const topPage = () => {
        APIS.topPage({}).then((res => {
            // console.log("API Success!!!!!!!!");
            
            // レスポンスセット
            setBannerData(res.bannerInfo);
            setCharacterBannerData(res.characterInfo);
            setNewsData(res.newsInfo);
            setRoadMapData(res.roadMapInfo);
            SetIsSuccess(true);

        })).catch((err) => {
            // console.log("API Error : " + err);
        });
    }

    useLayoutEffect(() => {
        topPage();
    }, []);
    
    return <View bannerData={banner} charBannerData={charBanner} newsData={newsData} roadmapData={roadMapData} isSuccess={isSuccess}/>;
};

export default Presenter;